import {
    GET_MANAGER_LEADS_LEAD_MANAGE,
    GET_MANAGER_LEADS_LEAD_MANAGE_SUCCESS,
    GET_MANAGER_LEADS_LEAD_MANAGE_FAILURE,
    COUNT_MANAGER_LEADS_SUCCESS,
    COUNT_MANAGER_LEADS_FAILURE,
    SET_MANAGER_LEAD_MANAGE_KEY,
    UPDATE_MANAGER_LEAD_MANAGE_KEY,
    SET_MANAGER_LEAD_MANAGE_LOADING,
    SET_MANAGER_LEAD_MANAGE_PAGINATION,
    SET_MANAGER_LEAD_MANAGE_NEW_KEY_VALUE,
} from '../constants/get_manager_leads.constants';

export const getManagerLeadsRequest = (filters, pagination) => ({
    type: GET_MANAGER_LEADS_LEAD_MANAGE,
    filters,
    pagination,
});

export const setManagerLeadManageLoading = loading => ({
    type: SET_MANAGER_LEAD_MANAGE_LOADING,
    loading,
});

export const setManagerLeadManagePagination = (path, value) => ({
    type: SET_MANAGER_LEAD_MANAGE_PAGINATION,
    path,
    value,
});

export const getManagerLeadsSuccess = manager_leads => ({
    type: GET_MANAGER_LEADS_LEAD_MANAGE_SUCCESS,
    manager_leads,
});

export const getManagerLeadsFailure = error => ({
    type: GET_MANAGER_LEADS_LEAD_MANAGE_FAILURE,
    error,
});

export const countManagerLeadsSuccess = manager_leads_count => ({
    type: COUNT_MANAGER_LEADS_SUCCESS,
    manager_leads_count,
});

export const countManagerLeadsFailure = error => ({
    type: COUNT_MANAGER_LEADS_FAILURE,
    error,
});

export const setManagerLeadManageKey = (path, value) => ({
    type: SET_MANAGER_LEAD_MANAGE_KEY,
    path,
    value,
});

export const setManagerLeadManageNewKey = ({ data, path, value }) => ({
    type: SET_MANAGER_LEAD_MANAGE_NEW_KEY_VALUE,
    data,
    path,
    value,
});

export const updateManagerLeadManageKey = data => ({
    type: UPDATE_MANAGER_LEAD_MANAGE_KEY,
    data,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Manager_special/redux/actions/get_manager_leads.actions.js